<script>
export default {
    name: "SliderTestIcon"
}
</script>
<template>
    <svg id="Group_963" data-name="Group 963" xmlns="http://www.w3.org/2000/svg" width="300.778" height="370.123" viewBox="0 0 300.778 370.123">
        <g id="Group_962" data-name="Group 962" transform="translate(30.285 111.383)">
            <ellipse id="Ellipse_62" data-name="Ellipse 62" cx="64.152" cy="64.152" rx="64.152" ry="64.152" transform="translate(0 0.801)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="1"/>
            <ellipse id="Ellipse_63" data-name="Ellipse 63" cx="44.133" cy="44.133" rx="44.133" ry="44.133" transform="translate(20.02)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="1"/>
        </g>
        <path id="Path_1092" data-name="Path 1092" d="M16168.7,2901.33V2531.207" transform="translate(-16074.259 -2531.207)" fill="none" stroke="#fff" stroke-width="1"/>
        <path id="Path_1093" data-name="Path 1093" d="M0,300.778V0" transform="translate(0 199.184) rotate(-90)" fill="none" stroke="#fff" stroke-width="1"/>
        <path id="Path_1094" data-name="Path 1094" d="M0,249.372V0" transform="translate(16.325 63.89) rotate(-30)" fill="none" stroke="#fff" stroke-width="1"/>
        <path id="Path_1095" data-name="Path 1095" d="M0,312.448V0" transform="translate(16.325 334.479) rotate(-150)" fill="none" stroke="#fff" stroke-width="1"/>
    </svg>
</template>
